<template>
  <div class="layout-wrapper">
    <PageLeft :collapsed="isCollapsed" />
    <div class="layout-right">
      <PageHeader :collapsed="isCollapsed" @toggle-sidebar="toggleSidebar" />
      <div class="layout_main">
        <router-view />
      </div>
      <PageFooter />
    </div>
  </div>
</template>

<script>
import PageFooter from '@/components/PageFooter.vue'
import PageHeader from '@/components/PageHeader.vue'
import PageLeft from '@/components/PageLeft.vue'

export default {
  name: 'PageLayout',
  components: {
    PageFooter,
    PageHeader,
    PageLeft
  },
  data() {
    return {
      isCollapsed: false
    }
  },
  methods: {
    toggleSidebar() {
      this.isCollapsed = !this.isCollapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  margin: 0;
  padding: 0;
}

.layout-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  overflow: hidden;
  min-width: 0;
}

.layout_main {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
</style>
